export default __webpack_public_path__ + "64622a0e3fd6076e6bda726bc446e425.png";